import {Action} from '@ngrx/store';
import {IUserServicesState} from '../state/user-services.state';

export enum SETTINGS_SERVICES_ACTION {
  INIT_SETTINGS_SERVICES = 'INIT_SETTINGS_SERVICES',
  RESET_SETTINGS_SERVICES = 'RESET_SETTINGS_SERVICES',
}
export class SetSettingsServices implements Action {
  readonly type = SETTINGS_SERVICES_ACTION.INIT_SETTINGS_SERVICES;

  constructor(public payload: IUserServicesState) {}
}
// eslint-disable-next-line max-classes-per-file
export class ResetSettingsServices implements Action {
  readonly type = SETTINGS_SERVICES_ACTION.RESET_SETTINGS_SERVICES;
}
export type SettingsServicesAction = SetSettingsServices | ResetSettingsServices;
